import { render, staticRenderFns } from "./button_language_sm.vue?vue&type=template&id=ab8e70c4&scoped=true"
import script from "./button_language_sm.vue?vue&type=script&lang=js"
export * from "./button_language_sm.vue?vue&type=script&lang=js"
import style0 from "./button_language_sm.vue?vue&type=style&index=0&id=ab8e70c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8e70c4",
  null
  
)

export default component.exports